// Vendors
import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';

const RefinementList = ({ items, refine, attribute }) =>
  items.map((item) => (
    <div
      className={`facetwp-checkbox${item.isRefined ? ' checked' : ''}`}
      style={{ backgroundColor: item.label }}
      key={item.label}
      onClick={() => refine(item.value)}
    >
      {item.label} <span className="facetwp-counter">({item.count})</span>
    </div>
  ));

export default connectRefinementList(RefinementList);
